import { Box, BoxProps } from "@mui/material";
import { assetUrl } from "../../utils";

export const KEIIcon = (props: BoxProps) => {
  return (
    <Box
      component="img"
      alt="kei-finance-icon"
      maxWidth="3rem"
      src={assetUrl("kei-icon.svg")}
      {...props}
    />
  );
};
